var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "redux-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1776 39.5295L87.472 37.5986C83.7293 14.4275 70.6847 8.08299 62.704 8.08299C44.8092 8.08299 35.826 25.6453 33.5327 35.116C29.1015 54.7563 36.6399 71.9876 41.2383 78.1481C50.3199 76.7683 55.8239 89.1815 48.3935 94.1467C38.2509 100.924 31.331 88.6298 35.1839 82.2858C23.7356 64.1903 24.3594 43.2995 26.1023 35.116C33.8079 5.10386 54.1755 0.416061 62.704 0.635112C84.1695 1.18645 94.2603 26.2889 95.1776 39.5295ZM45.6415 46.701C45.6415 36.4947 58.5759 35.1155 62.1535 42.5633C90.7743 42.5633 106.644 55.804 112.515 61.3209C116.918 65.4586 126 77.5959 126 90.5607C126 103.801 120.221 109.484 114.717 113.456C107.837 118.421 102.608 120.628 91.8752 120.628C83.8279 120.628 77.413 118.01 73.0925 116.247L73.0924 116.247C72.8327 116.141 72.5804 116.038 72.3359 115.939L78.3903 110.422C85.6556 113.511 93.1594 113.732 96.0032 113.456C114.717 111.911 118.845 97.7327 118.845 90.5607C118.845 78.1476 108.662 67.6537 103.709 63.5277C88.0774 50.5077 67.6575 49.1837 62.1535 50.287C55.5487 60.2175 45.6415 53.0455 45.6415 46.701ZM87.4719 84.492C95.1775 84.7679 98.8545 72.3377 89.9488 67.3895C83.4946 63.8035 72.6111 72.6306 80.0415 82.0094C78.3359 87.3696 68.2417 102.067 49.3026 109.458C43.3008 111.8 29.2076 115.64 18.3763 109.622C12.1182 106.144 1.74781 95.6517 9.47246 78.497C10.6104 75.8702 13.8905 69.9505 20.1086 65.079L18.2299 57.0966C17.9579 57.3173 17.6766 57.5434 17.3871 57.7761C13.8295 60.6355 9.04045 64.4847 5.21567 71.401C0.0122939 80.8102 -0.597143 86.464 0.39991 94.9028C1.19756 101.654 3.35401 109.475 14.9074 115.894C26.2201 122.18 41.2136 120.102 46.9587 118.248C54.6189 115.776 73.5962 109.583 87.4719 84.492Z",
    fill: "url(#paint0_linear_37_260)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_260",
    x1: 32.2873,
    y1: 11.6114,
    x2: 116.885,
    y2: 109.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduxLogo);
export default __webpack_public_path__ + "static/media/redux-logo.0aa182bcde794d4a6a20142e7ea71fcd.svg";
export { ForwardRef as ReactComponent };